export function isExpandableColumnGridModel(model) {
  return (model === null || model === void 0 ? void 0 : model.hasExpandableColumns) !== undefined;
}

/**
 * Expandable grid model. Allows for a grid with columns that can expand (e.g. Pivot Table)
 */
//# sourceMappingURL=ExpandableColumnGridModel.js.map